<template>
	<form class="flex justify-center max-w-full">
		<div
			class="flex justifiy-between max-w-full gap-2">
			<input
				v-for="(item, index) of code"
				:key="index"
				type="tel"
				maxlength="1"
				pattern="[0-9]"
				@input="onInput"
				@paste="(e) => {handlePaste(e, index)}"
				@keyup.backspace="(e) => {handleBackspace(e, index)}"
				@keyup.left="(e) => {handleLeft(e)}"
				@keyup.right="(e) => {handleRight(e)}"
				v-model="code[index]"
				class="focus:ring-dbBlue focus:border-dbBlue border-gray-300 flex-none w-[52px] h-[52px] text-center text-xl min-w-0">
		</div>
	</form>
</template>

<script lang="ts">
	// name the component
	export default { name: 'TwConfirmationCode' }
</script>

<script setup lang="ts">

	import {
		ref,
		nextTick
	} from "vue"

	//eslint-disable-next-line
	const props = defineProps({
		modelValue: {
			type: String,
			default: null
		}
	})

	const emit = defineEmits([
		'update:modelValue'
	])

	const code = ref([null,null,null,null,null,null])

	function handleLeft(e: any) {
		const previousInput = e.target.previousElementSibling
		if (!previousInput) return
		previousInput.focus()
		return
	}

	function handleRight(e: any) {
		const nextInput = e.target.nextElementSibling
		if (!nextInput) return
		nextInput.focus()
		return
	}

	async function handleBackspace(e: any,i: number) {
		if(i === 0) return
		const input = e.target
		const sibling = input.previousElementSibling
		
		if (input.value) {
			input.value = ''
			code.value[i] = null
		}
		if(sibling.value) {
			sibling.focus()
			sibling.value = ''
			code.value[i-1] = null
		}
		emit('update:modelValue', code.value.join(''))
		await nextTick()

		return
	}

	async function handlePaste(e: any,i: number) {
		if(i > 0) return
		e.preventDefault()
		const paste = e.clipboardData.getData('text')
		for(let i = 0; i < code.value.length ; i++) {
			code.value[i] = paste.charAt(i) || ''
		}

		emit('update:modelValue', code.value.join(''))
		await nextTick()
	}

	// update modeled value
	const onInput = async ({ target }: any) => {
		emit('update:modelValue', code.value.join(''))
		await nextTick()

		const input = target
		const nextInput = input?.nextElementSibling
		if (nextInput && input.value) {
			nextInput.focus()
			if (nextInput.value) {
				nextInput.select()
			}
		}

		return
	}
</script>